import script from "./LiveStatsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiveStatsView.vue?vue&type=script&setup=true&lang=ts"

import "./LiveStatsView.vue?vue&type=style&index=0&id=38adb46a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38adb46a"]])

export default __exports__